import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const RequestCreateAnonymousSuccess = withAsync({
    loader: lazyForPaint(
        () => import(/* webpackChunkName: "request-create-anonymous-success" */ './request-create-anonymous-success')
    ),
});
